export function SET_RERENDER(payload) {
	return {
		type: 'SET_RERENDER',
		payload: payload
	};
}
